export default () => ({
  vehicles: [],
  vehicle: null,
  defaultVehicle: {
    contact: null,
    vehicle: -1,
    year: '2007',
    make: 0,
    model: '',
    vin: ''
  }
})



// WEBPACK FOOTER //
// ./src/store/modules/vehicles/state.js